import { Link } from "react-router-dom";
import Logo from "../ui/Logo.jsx";
import styles from "./Footer.module.css";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.foot}>
      <div className={styles.left}>
        <Logo size={22} />
        <span>Aya Technologies · Ingeniería aplicada</span>
      </div>

      <div className={styles.mid}>
        <span className="mono-tag">// {year}</span>
      </div>

      <div className={styles.right}>
        <a href="mailto:ventas@ayatech.com.pe">
          ventas@ayatech.com.pe
        </a>
        <span className={styles.dot}>·</span>
        <Link to="/proyectos">repositorio</Link>
      </div>
    </footer>
  );
}
